import TmLogo from "@assets/TMLogo.svg";
import Image from "@elements/ResponsiveImage/Image";
import { TM_PROD_DOMAIN } from "@helper/getEnvVariables";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

type PromotTMProps = {
  className?: string;
};

export default function PromotTM({ className }: PromotTMProps) {
  return (
    <div
      id="promote-tm"
      className={twMerge(
        "py-6 bg-orange-100 grid justify-center items-center gap-3",
        className,
      )}
    >
      <div className="font-primary text-base text-center xmd:text-xl leading-5 xmd:leading-6 text-red-500 font-bold">
        Catch up on the latest Tamil news with
      </div>
      <Link
        reloadDocument
        to={TM_PROD_DOMAIN}
        target="_blank"
        rel="noreferrer"
        className="block"
      >
        <Image
          objectFit="contain"
          src={TmLogo}
          className={twMerge("mx-auto w-[304px] h-[70px]")}
          srcWidth={304}
          srcHeight={70}
          alt="promote-tm"
          dataTestId="image"
        />
      </Link>
    </div>
  );
}
